<template>
<div>
<v-card>
  <v-card-actions class="pa-2" style="background-color:#707070;color:white; height:40px;">
    <p class="mb-0">検索</p>
    <v-spacer></v-spacer>
    <v-icon color="white" @click="$emit('close',false)">mdi-close</v-icon>
  </v-card-actions>
  <div style="overflow: scroll; max-height: 80vh;">
    <v-card-actions>
      <v-text-field class="px-4" v-model="keyword" clearable flat outlined placeholder="キーワードを入力" hide-details prepend-inner-icon="mdi-magnify" ></v-text-field>
    </v-card-actions>
    <v-card-text class="cloud--text pb-0">検索する期間の指定</v-card-text>
    <v-card-actions class="px-2 py-0 mx-auto d-flex" style="width:300px;">
      <v-select class="text-caption py-0" :items="years" v-model="voteStartYYYY" label="年"></v-select>
      <v-select class="text-caption py-0" :items="months" v-model="voteStartMO" label="月"></v-select>
      <v-select class="text-caption py-0" :items="ddddd" v-model="voteStartDD" label="日"></v-select>
      <v-select class="text-caption py-0" :items="hours" v-model="voteStartHH" label="時"></v-select>
      <v-select class="text-caption py-0" :items="['まで','から']" v-model="kara"></v-select>
    </v-card-actions>
    <v-card-actions class="px-2 py-0 mx-auto d-flex" style="width:300px;">
      <v-select class="text-caption py-0" :items="years" v-model="voteEndYYYY" label="年" :disabled="kara==='まで'"></v-select>
      <v-select class="text-caption py-0" :items="months" v-model="voteEndMO" label="月" :disabled="kara==='まで'"></v-select>
      <v-select class="text-caption py-0" :items="ddddd" v-model="voteEndDD" label="日" :disabled="kara==='まで'"></v-select>
      <v-select class="text-caption py-0" :items="hours" v-model="voteEndHH" label="時" :disabled="kara==='まで'"></v-select>
      <v-card-text class="cloud--text text-center px-0">の投稿</v-card-text>
    </v-card-actions>
    <v-card-text v-if="tags" class="cloud--text pb-0">指定したタグに絞り込む</v-card-text>
    <v-select
      v-if="tags"
      class="mx-auto"
      v-model="tag"
      :items="tags.title"
      menu-props="{ top: true, offsetY: true }"
      label="絞り込むハッシュタグを選択"
      hide-details
      prepend-icon="#"
      single-line
      dense
      outlined
      background-color="white"
      clearable
      @change="onChange(type);"
    >
    </v-select>
    <v-card-text v-if="tags" class="cloud--text text-right py-0">の投稿</v-card-text>
    <v-radio-group column mandatory class="px-6" v-model="radio">
      <v-radio
        v-for="box in checkboxes"
        :key="box.value"
        :value="box.value"
        @change="onChange(box.value);"
        :label="box.text"
        color="deepAqua"
      ></v-radio>
    </v-radio-group>
  </div>
  <v-card-actions>
    <v-spacer></v-spacer>
    <v-btn class="white--text" color="deepAqua" @click="submitkeyword()">検索</v-btn>
    <v-btn @click="returnSearch()">クリア</v-btn>
    <v-spacer></v-spacer>
  </v-card-actions>
</v-card>
</div>
</template>


<script>
import Vue from 'vue'
import VueMq from 'vue-mq'
Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    sp: 959,
    pc: 960
  },
  defaultBreakpoint: 'pc' // customize this for SSR
})

function filteredList(ideaList, keyword) {
  return ideaList.filter((idea) =>
    idea.includes(keyword)
  );
}

function sortByData(sortIdeaList){
  //console.log("before", sortIdeaList);
  //console.log("20220806181448832" > "20220806181448831");
  //console.log("20220806181448832" < "20220806181448831");
  sortIdeaList.sort(function(a,b){
    if(a.sort < b.sort) return 1;
    if(a.sort > b.sort) return -1;
    return 0;
  });
  //console.log("after", sortIdeaList);
  return sortIdeaList;
}


// <IdeaSearch :ideaList = props>  </IdeaSearch>
export default {
  name: "IdeaSearch",
  props: ['ideaList','uid','tags'],
  data() {
    return {
      //newShowedIdea: this.showedIdea,
      ideaList_: [],
      keyword: "",
      tag:"",
      type: "all",
      radio: "",
      checkboxState: {
        all:true,
        ownIsNot: false,
        aonIsNot: false,
        mapIsNot:false,
      },
      kara: "まで",
      years: [2023,2022],
      months: [1,2,3,4,5,6,7,8,9,10,11,12],
      ddddd: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31],
      day_31: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31],
      day_30: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30],
      day_29: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29],
      day_28: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28],
      hours: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23],
      voteStartYYYY: null,
      voteStartMO: null,
      voteStartDD: null,
      voteStartHH: null, 
      voteEndYYYY: null,
      voteEndMO: null,
      voteEndDD: null,
      voteEndHH: null,
      donotclose: false,
    };
  },
  created() {
    //console.log(this.ideaList);
  },
  mounted() {
    // sessionStorageに検索ワードがあれば、取得し検索を実行
    const searchWord = sessionStorage.getItem('searchWord')
    if (searchWord) {
      if (this.$mq === 'pc') this.donotclose = true;
      sessionStorage.removeItem('searchWord')
      this.keyword = searchWord;
      this.submitkeyword();
    }
  },
  computed: {
    checkboxes() {
      return [
        {text: "全て", value: "all" },
        {text: "自分の投稿", value: "ownIsNot" },
        {text: "匿名ではない者の投稿", value: "anoIsNot" },
        {text: "位置情報ありの投稿", value: "mapIsNot" },
        {text: "詳細情報ありの投稿", value: "supplementIsNot" },
      ];
    }
  },
  watch:{
    tag:{
      handler(v,ov){
        if((ov&&ov.length>0)&&!v) this.onChange(this.type)
      }
    },
    keyword:{
      handler(v,ov){
        if((v===undefined||v===null||v.length===0)&&(ov!==undefined&&ov!==null&&ov.length>0)) {
          this.onChange(this.type)
          this.$emit('updateSearchWord', v)
        }
      }
    },
    voteStartMO:{ //月によって変わる日数の調整
      handler: function(val, oldVal) {
        if(val!==null){
          let v = val.toString()
          if(v==="4"||v==="6"||v==="9"||v==="11"){
            this.ddddd = this.day_30
            if(this.voteStartDD>30){
              this.voteStartDD = 30
            }
          }
          else if(v==="2"){
            if(this.voteEndYYYY%4===0){
              this.ddddd = this.day_29
            }
            else{
              this.ddddd = this.day_28
            }
            if(this.voteStartDD>28){
              this.voteStartDD = 28
            }
          }
          else{
            this.ddddd = this.day_31
          }          
        }
      },
      deep: true,
      immediate: false
    },
    voteStartYYYY:{ //年によって変わる２月の日数調整。上と似てるが消さない
      handler: function(v, oldVal) {
        if(v!==null){
          if(v%4===0){
            if(this.voteStartMO===2) this.ddddd = this.day_29
          }
          else{
            if(this.voteStartMO===2){
              this.ddddd = this.day_28
              if(this.voteStartDD>28) this.voteStartDD = 28
            }
          }          
        }
      }
    },
    voteEndMO:{ //月によって変わる日数の調整
      handler: function(val) {
        if(val!==null){
          let v = val.toString()
          if(v==="4"||v==="6"||v==="9"||v==="11"){
            this.ddddd = this.day_30
            if(this.voteEndDD>30){
              this.voteEndDD = 30
            }
          }
          else if(v==="2"){
            if(this.voteEndYYYY%4===0){
              this.ddddd = this.day_29
            }
            else{
              this.ddddd = this.day_28
            }
            if(this.voteEndDD>28){
              this.voteEndDD = 28
            }
          }
          else{
            this.ddddd = this.day_31
          }          
        }

      },
      deep: true,
      immediate: false
    },
    voteEndYYYY:{ //年によって変わる２月の日数調整。上と似てるが消さない
      handler: function(v) {
        if(v!==null){
          if(v%4===0){
            if(this.voteEndMO===2) this.ddddd = this.day_29
          }
          else{
            if(this.voteEndMO===2){
              this.ddddd = this.day_28
              if(this.voteEndDD>28) this.voteEndDD = 28
            }
          }          
        }
      }
    },
  },
  methods: {
    toDoubleDigits(num) {
      num += "";
      if (num.length === 1) {
        num = "0" + num;
      }
      return num; 
    },
    toDoubleDigits2(num) {
      num += "";
      if (num.length === 16) {
        num = num + "0";
      }
      else if (num.length === 15) {
        num = num + "00";
      }
      else if (num.length === 14) {
        num = num + "000";
      }
      else if (num.length === 13) {
        num = num + "0000";
      }
      return Number(num); 
    },
    myConsole(msg) {
        //一括削除できるように
        //console.log(msg);
    },
    submitkeyword() {
      let isOne = false, isTwo = false, startSort = "", endSort = ""
      let searchIdeaList = [], newSearchIdeaList;
      //console.log(this.voteStartYYYY,this.voteStartMO,this.voteStartDD,this.voteStartHH,this.voteStartYYYY&&this.voteStartMO&&this.voteStartDD&&this.voteStartHH)
      if(this.ideaList_.length===0) this.ideaList_ = this.ideaList
      if(this.voteStartYYYY>0&&this.voteStartMO>0&&this.voteStartDD>0&&this.voteStartHH>=0){
        //console.log("時間設定１")
        let mm = this.toDoubleDigits(this.voteStartMO)
        let dd = this.toDoubleDigits(this.voteStartDD)
        let hh = this.toDoubleDigits(this.voteStartHH)
        let mi = "00"
        let se = "00"
        let ms = "000"
        startSort = this.voteStartYYYY + mm + dd + hh + mi + se + ms
        startSort = Number(startSort)
        //console.log(startSort)
        if(this.kara==="まで") isOne = true, isTwo = false
        else if(this.voteEndYYYY>0&&this.voteEndMO>0&&this.voteEndDD>0&&this.voteEndHH>=0&&this.kara==="から"){
          //console.log("時間設定２")
          isTwo = true, isOne = false
          let mm = this.toDoubleDigits(this.voteEndMO)
          let dd = this.toDoubleDigits(this.voteEndDD)
          let hh = this.toDoubleDigits(this.voteEndHH)
          let mi = "00"
          let se = "00"
          let ms = "000"
          endSort = this.voteEndYYYY + mm + dd + hh + mi + se + ms
          endSort = Number(endSort)
          //console.log(endSort)
        }
      }
      if(this.keyword!==undefined&&this.keyword!==null&&this.keyword.length>0){
        //console.log("this.ideaList.length",this.ideaList.length);
        //searchidealistに検索した結果を入力していきます．
        //console.log(isOne,isTwo,startSort,endSort)
        for (let i = 0; i < this.ideaList_.length; i++) {
          if (this.ideaList_[i].content.includes(this.keyword)){
            if(isOne&&startSort){
              //console.log(Number(this.toDoubleDigits2(this.ideaList_[i].sort)) < startSort, Number(this.toDoubleDigits2(this.ideaList_[i].sort)) , startSort)
              if(Number(this.toDoubleDigits2(this.ideaList_[i].sort)) < startSort) searchIdeaList.push(this.ideaList_[i]);
            }
            else if(isTwo&&startSort&&endSort){
              if(startSort < Number(this.toDoubleDigits2(this.ideaList_[i].sort)) && Number(this.toDoubleDigits2(this.ideaList_[i].sort)) < endSort) searchIdeaList.push(this.ideaList_[i]);
            }
            else searchIdeaList.push(this.ideaList_[i]);
          }
        }
        //console.log("searchIdeaList",searchIdeaList,this.tag);
        newSearchIdeaList = sortByData(searchIdeaList);
        this.$emit('updateSearchWord', this.keyword);
        this.$emit('newshowedIdea', newSearchIdeaList);
      }
      else{
        //console.log("無キーワード",isOne,isTwo)
        if(isOne||isTwo){
          //console.log("無キーワード時間設定")
          for (let i = 0; i < this.ideaList_.length; i++) {
            if(isOne&&startSort){
              if(Number(this.toDoubleDigits2(this.ideaList_[i].sort)) < startSort) searchIdeaList.push(this.ideaList_[i]);
              //console.log(this.ideaList_[i].content,Number(this.toDoubleDigits2(this.ideaList_[i].sort)) < startSort,Number(this.toDoubleDigits2(this.ideaList_[i].sort)) , startSort)
            }
            else if(isTwo&&startSort&&endSort){
              if(startSort < Number(this.toDoubleDigits2(this.ideaList_[i].sort)) && Number(this.toDoubleDigits2(this.ideaList_[i].sort)) < endSort) searchIdeaList.push(this.ideaList_[i]);
            }
            else searchIdeaList.push(this.ideaList_[i]);
          } 
          newSearchIdeaList = sortByData(searchIdeaList);
        }
        else newSearchIdeaList = this.ideaList_
        this.$emit('newshowedIdea', newSearchIdeaList);
      }
      if(!this.donotclose) this.$emit("close",false)
      this.donotclose = false;
      return newSearchIdeaList;
    },
    returnSearch() {
      this.keyword = ""
      this.radio = ""
      this.tag = ""
      this.kara="まで"
      this.voteStartYYYY= null
      this.voteStartMO= null
      this.voteStartDD= null
      this.voteStartHH= null
      this.voteEndYYYY= null
      this.voteEndMO= null
      this.voteEndDD= null
      this.voteEndHH= null
      let searchIdeaList = [];
      searchIdeaList = sortByData(this.ideaList);
      //console.log("searchIdeaList",searchIdeaList);
      this.$emit('newshowedIdea', searchIdeaList);
      return searchIdeaList;
    },
    onChange(name) {
      this.type = name
      let ideaList = this.ideaList
      this.ideaList_ = this.ideaList
      if(this.tag){
        ideaList = this.ideaList.filter((el)=>{
          if(el.tag&&el.tag.title&&el.tag.title===this.tag){
            return true
          } 
        })        
      }
      //console.log(ideaList)
      if (name=="all"){
        let searchIdeaList = [];
        searchIdeaList = ideaList.sort(function(a,b){
            if(a.sort < b.sort) return 1;
            if(a.sort > b.sort) return -1;
            return 0;
            });
        //console.log("searchIdeaList",searchIdeaList);
        this.$emit('newshowedIdea', searchIdeaList);
        this.ideaList_ = searchIdeaList
      }else  if (name=="ownIsNot"){
        let searchIdeaList = [];
        //console.log(ideaList)
        if(this.checkboxState[name]==true){
          for (let i = 0; i < ideaList.length; i++) {
            searchIdeaList.push(ideaList[i]);
          }
        }else{
          for (let i = 0; i < ideaList.length; i++) {
            //console.log(this.ideaList2[i])
            if (ideaList[i].author== this.uid){
              //console.log("yes")
              searchIdeaList.push(ideaList[i]);
            }
          }
        }
        //console.log("searchIdeaList",searchIdeaList);
        this.$emit('newshowedIdea', searchIdeaList);
        this.ideaList_ = searchIdeaList
      }else  if (name=="anoIsNot"){
        let searchIdeaList = [];
        //console.log(ideaList)
        if(this.checkboxState[name]==true){
          for (let i = 0; i < ideaList.length; i++) {
            searchIdeaList.push(ideaList[i]);
          }
        }else{
          for (let i = 0; i < ideaList.length; i++) {
            //console.log(this.ideaList2[i])
            if (ideaList[i].anonymous== false){
              //console.log("yes")
              searchIdeaList.push(ideaList[i]);
            }
          }
        }
        //console.log("searchIdeaList",searchIdeaList);
        this.$emit('newshowedIdea', searchIdeaList);
        this.ideaList_ = searchIdeaList
      }else  if (name=="mapIsNot"){
        let searchIdeaList = [];
        //console.log(ideaList)
        if(this.checkboxState[name]==true){
          for (let i = 0; i < ideaList.length; i++) {
            searchIdeaList.push(ideaList[i]);
          }
        }else{
          for (let i = 0; i < ideaList.length; i++) {
            //console.log(this.ideaList2[i])
            if (ideaList[i].latlngInputLat){
              if (ideaList[i].latlngInputLat!= 0){
                //console.log("yes")
                searchIdeaList.push(ideaList[i]);
              }
            }
          }
        }
        //console.log("searchIdeaList",searchIdeaList);
        this.$emit('newshowedIdea', searchIdeaList);
        this.ideaList_ = searchIdeaList
      }else  if (name=="supplementIsNot"){
        let searchIdeaList = [];
        //console.log(ideaList)
        if(this.checkboxState[name]==true){
          for (let i = 0; i < ideaList.length; i++) {
            searchIdeaList.push(ideaList[i]);
          }
        }else{
          for (let i = 0; i < ideaList.length; i++) {
            //console.log(this.ideaList2[i])
            if (ideaList[i].supplement){
              if (ideaList[i].supplement!= ""){
                //console.log("yes")
                searchIdeaList.push(ideaList[i]);
              }
            }
          }
        }
        //console.log("searchIdeaList",searchIdeaList);
        this.$emit('newshowedIdea', searchIdeaList);
        this.ideaList_ = searchIdeaList
      }
    }
  },
};
</script>
<style scoped>
</style>